import { render } from "./GolfSettings.vue?vue&type=template&id=52dd69ca&scoped=true"
import script from "./GolfSettings.vue?vue&type=script&lang=js"
export * from "./GolfSettings.vue?vue&type=script&lang=js"

import "./GolfSettings.vue?vue&type=style&index=0&id=52dd69ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52dd69ca"]])

export default __exports__